import { isDev, isStg } from 'utils/env';

import styles from './styles.module.css';

/**
 * @param {{ uuid: string, title: string, link: string }[]} menuItems
 * @returns {{ uuid: string, title: string, link: string }[]}
 */
export const getVisibleMenuItemsByRole = (menuItems) => menuItems;

/**
 * Returns the CSS class for the current deployment environment.
 * Returns `''` in production, `styles.stg` on staging, `styles.dev` on dev/local.
 *
 * @returns {string}
 */
export const getEnvClass = () => {
	if (isStg()) return styles.stg;
	if (isDev()) return styles.dev;
	return '';
};
